import React from 'react'
import { IProspectsCardsProps } from '../ProspectsCards'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { GridContainer, GridItem } from 'src/components/common/grids'
import { Button } from '@habitech/call-to-action'
import Icon from 'src/components/common/Icon'
import { ProspectsNotesContainer } from './ProspectsNotes.styles'
import { formatDate } from 'src/helpers/formatDate'
import { UseHandleProspectsNotes } from './ProspectsNotes.helper'

const ProspectsNotes = ({ prospect, loading }: IProspectsCardsProps) => {
    const { value, error, loadingNote, sendNote, handleKeyDown, handleChange } = UseHandleProspectsNotes(prospect)

    if (loading) return (
        <>
            <SkeletonLoader height='105px' />
            <GridContainer>
                <GridItem lg={8}>
                    <SkeletonLoader height='18px' />
                </GridItem>
                <GridItem lg={4}>
                    <SkeletonLoader height='18px' />
                </GridItem>
            </GridContainer>
            <SkeletonLoader height='18px' width='190px' />
        </>
    )

    return (
        <ProspectsNotesContainer noteError={error}>
            <textarea
                className='note-textarea'
                placeholder='Escribe una nota'
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                data-testid='textarea'
            />
            {
                error && (
                    <small className='error-note'>
                        La nota no puede superar los 500 caracteres
                    </small>
                )
            }
            <div className="container-info-notes">
                <small className='last-date'>{
                    prospect?.note_updated_at
                    && `Última actualización de la nota: ${formatDate(prospect.note_updated_at, '', true)}`
                }
                </small>
                <small className='counter'>{value.length}/500</small>
            </div>
            <small className='note-by'>{
                prospect?.note_updated_by_fullname
                && `Actualizado por: ${prospect.note_updated_by_fullname}`
            }
            </small>
            <div className="container-buttons-notes">
                {/* <button className="btn-see-notes">
                    <Icon disableFill icon='pcom-icon-Lista' size={18} />
                    Ver Notas
                </button> */}
                <Button
                    dataId="add-note"
                    originType="pcom"
                    variant='stroke'
                    disabled={error || loadingNote}
                    onClick={sendNote}
                    loading={loadingNote}
                >
                    <Icon disableFill icon='pcom-icon-circle-plus-outline' size={18} />
                    Agregar Nota
                </Button>
            </div>
        </ProspectsNotesContainer>
    )
}

export default ProspectsNotes